import { Popconfirm, Popover, Table } from "antd";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { Fragment } from "react";
import moment from "moment";

export const PendingTable = ({ FlooringCases, DeleteFloorCases, pagePermission }) => {
  const navigate = useNavigate();
  console.log("pagePermission", pagePermission);

  const columns = [
    {
      title: "Application ID",
      dataIndex: "application_uniqueId",
      key: "application_uniqueId",
      width: 140,
    },
    {
      title: "Date & Time",
      dataIndex: "created_at",
      key: "created_at",
      width: 120,
      render: (text, record) => {
        return (
          <Fragment>
            <div className="text-[#1B252F] text-[13px]">
              {moment(record.created_at).format("DD-MM-YYYY HH:MM")}
            </div>
          </Fragment>
        );
      },
    },
    {
      title: "Flooring Type",
      dataIndex: "flooring_product",
      key: "flooring_product",
      width: 140,
      render: (flooringType) => (
        <div className="table-info-block">
          <span>
            {flooringType === "BODYONLY" ? "BODY ONLY" : flooringType}
          </span>
        </div>
      ),
    },
    {
      title: "Veh/Chassis No",
      dataIndex: "vehicle_reg_no",
      key: "vehicle_reg_no",
      width: 140,
      render: (vehChassisNo, item) => (
        <div className="ven-block">
          <h2>{`${item?.vehicle_reg_no !== null ? item?.vehicle_reg_no : "--"
            }`}</h2>
          <p>{`${item?.chassis_no !== null ? item?.chassis_no : "--"}`}</p>
        </div>
      ),
    },
    {
      title: "Make/Model",
      dataIndex: "make_model",
      key: "make_model",
      width: 180,
      render: (makeModel) => (
        <div className="make-model-block">
          <h2>{`${makeModel !== null ? makeModel : "--"}`}</h2>
        </div>
      ),
    },
    {
      title: "Intended Floor Amt",
      dataIndex: "intended_floor_amount",
      key: "intended_floor_amount",
      width: 140,
      render: (intendedFloorAmt) => (
        <div>
          <span>
            ${intendedFloorAmt !== null
              ? `${intendedFloorAmt.slice(0, intendedFloorAmt.indexOf("."))}`
              : "--"}
          </span>
        </div>
      ),
    },
    {
      title: "Case Exp",
      dataIndex: "expiry_date",
      key: "expiry_date",
      width: 100,
      render: (expiry_date) => (
        <div>
          <span>{expiry_date !== null ? `${expiry_date}` : "--"}</span>
        </div>
      ),
    },
    {
      title: "Flooring Status",
      dataIndex: "agent_approved_status",
      key: "agent_approved_status",
      width: 140,
      render: (agent_approved_status) => (
        <div className="flooring-Status-block">

          <Popover content={"Issued"}>
            <span className={`${"status-issued"}`}>
              {agent_approved_status?.approved}
            </span>
          </Popover>
          <Popover content={"Pending"}>

            <span className={`${"status-rejected"}`}>
              {agent_approved_status?.pending}
            </span>
          </Popover>
          <Popover content={"Rejected"}>

            <span className={`${"status-pending"}`}>
              {agent_approved_status?.rejected}
            </span>
          </Popover>
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: 140,
      render: (action, item) => (

        < div >
          {pagePermission?.update_permission == 1 && (
            <span
              className="view-resume-block"
              onClick={() => {
                navigate("/flooring-cases/view", {
                  state: {
                    appId: item?.id,
                    date: {
                      submitted_date: item?.submitted_date,
                      expiry_date: item?.expiry_date,

                    },
                    pagePermission: pagePermission
                  },
                });
              }}
            >
              <EyeOutlined className="mt-1" />
              <span>View</span>
            </span>
          )}

          < Popconfirm
            title="Delete Flooring Case"
            description="Are you sure to delete..?"
            onConfirm={() => {
              DeleteFloorCases(item?.id);
            }}
            onCancel={() => { }}
            okText="Yes"
            cancelText="No"
          >
            {pagePermission?.delete_permission == 1 && (
              <span
                className="table-delete-block"
                onClick={() => {
                }}
              >
                <DeleteOutlined className="mt-1" />
                <span>Delete</span>
              </span>
            )}
          </Popconfirm >
        </div >
      ),
    },
  ];

  return (
    <Table
      dataSource={FlooringCases}
      columns={columns}
      scroll={{ x: "calc(400px + 50%)", y: 500 }}
    />
  );
};
